import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
// import Logo from "./"
import { useLocation } from 'react-router-dom';
import { useUserContext } from '../../context/userContext';

export default function MainSidebar() {
  const navigate = useNavigate();
  const location = useLocation()
  const token = localStorage.getItem("token")
  const { userDetails,langPreference } = useUserContext();

  const handleLogout = () => {
    localStorage.removeItem("token");

    window.location.reload();
    navigate("/");
  }

  const path = location.pathname
  const search = location?.search
  const tallyAdminRoles = ["admin", "owner", "gm/ho", "gmho"];
  const roleName = (userDetails?.roleId?.type || userDetails?.roleId?.name || "").toLowerCase().replace(/[^a-z0-9]/g, "");
  const canAccessTallySetup = tallyAdminRoles.includes(roleName);
  const canAccessSiteUsers = canAccessTallySetup;
  const canAccessSiteSettings = ["admin", "owner"].includes(roleName);
  const isInspector = (userDetails?.roleId?.type || roleName) === "inspector";
  const permissions = userDetails?.roleId?.permission || [];
  const canAccessReports = isInspector
    ? permissions.includes("dlrRead") || permissions.includes("cpcRead") || permissions.includes("hindranceRead")
    : permissions.includes("reportRead") || permissions.includes("dlrRead") || permissions.includes("cpcRead") || permissions.includes("hindranceRead");
  const isReportsPath = (isInspector && path === "/hindrance") || path === "/reports/hindrance" || path === "/report" || path === "/dlr/report" || path === "/reports/concrete-pour";
  const isDailyReportPath = path.startsWith("/hindrance") || path.startsWith("/concrete-pour-cards") || path === "/dpr" || path.startsWith("/dpr/") || path === "/dlr" || path.startsWith("/dlr/");
  
  return (
    <>
      {token && <div className="side-nav">
        <div className="nav flex-column nav-pills " id="v-pills-tab" role="tablist" aria-orientation="vertical">
          {!isInspector && <Link to="/dashboard" className={`nav-link ${path.includes("dashboard") ? "active" : ""}`}> <i className="bi bi-house-door-fill"></i>{langPreference?.dashboard || "Dashboard"} </Link>}
          {userDetails?.roleId?.permission.includes("dailyReport") &&
            <Link to="/super-admin/daily-report" className={`nav-link ${path.includes("super-admin/daily-report") ? "active" : ""}`}><span className='pr-2'><img src='/purchase_order.png' className='tab-icon'/></span> {langPreference?.daily_report || "Daily Report"}</Link>
          }
          {userDetails?.roleId?.permission.includes("poRead") &&
            <Link to="/purchase" className={`nav-link ${path.includes("purchase") ? "active" : ""}`}><span className='pr-2'><img src='/purchase_order.png' className='tab-icon'/></span> {langPreference?.purchase_order || "Purchase Order"}</Link>
          }
          {userDetails?.roleId?.permission.includes("challanRead") &&
            <Link to="/challan" className={`nav-link ${path.includes("challan") ? "active" : ""}`} ><span className='pr-2'><img src='/challan.png' className='tab-icon'/></span> {langPreference?.challan || "Challan"}</Link>
          }
          {userDetails?.roleId?.permission.includes("voucherRead") &&
            <Link to="/voucher" className={`nav-link ${path.includes("voucher") ? "active" : ""}`} ><span className='pr-2'><img src='/voucher.png' className='tab-icon'/></span> {langPreference?.voucher || "Voucher"}</Link>
          }
            {userDetails?.roleId?.permission.includes("cashbookRead") &&
          <Link to="/cashbook" className={`nav-link ${path.includes("cashbook") ? "active" : ""}`} ><span className='pr-2'><img src='/my_cashbook.png' className='tab-icon'/></span>{langPreference?.my_cashbook || "My Cashbook"}</Link>}
          {userDetails?.roleId?.permission.includes("uploadRead") && <Link to="/upload" className={`nav-link ${path.includes("upload") ? "active" : ""}`}><span className='pr-2'><img src='/upload.png' className='tab-icon'/></span> {langPreference?.upload || "Upload"}</Link>}
          {canAccessReports && <div className="accordion accordion-flush" id="reports_menu">
            <div className="accordion-item">
              <h2 className="accordion-header" id="reports-heading">
                <button className={`accordion-button ${isReportsPath ? "" : "collapsed"}`} type="button" data-bs-toggle="collapse" data-bs-target="#reports-collapse" aria-expanded={isReportsPath} aria-controls="reports-collapse">
                  {langPreference?.reports || "Reports"}
                </button>
              </h2>
              <div id="reports-collapse" className={`accordion-collapse collapse ${isReportsPath ? "show" : ""}`} aria-labelledby="reports-heading" data-bs-parent="#reports_menu">
                <div className="accordion-body">
                  {!isInspector && permissions.includes("reportRead") && <Link to="/report" className={`nav-link ${path === "/report" ? "active" : ""}`}><span className='pr-2'><img src='/my_cashbook.png' className='tab-icon' alt="" /></span> {langPreference?.purchase_reports || "Purchase Reports"}</Link>}
                  {permissions.includes("dlrRead") && <Link to="/dlr/report" className={`nav-link ${path === "/dlr/report" ? "active" : ""}`}><span className='pr-2'><img src='/dpr.png' className='tab-icon' alt="" /></span> {langPreference?.periodic_dlr_report || "DLR Report"}</Link>}
                  {permissions.includes("cpcRead") && <Link to="/reports/concrete-pour" className={`nav-link nav-link--compact-icon ${path === "/reports/concrete-pour" ? "active" : ""}`}><i className="bi bi-clipboard-check" aria-hidden="true"></i><span>{langPreference?.concrete_pour || "Concrete Pour"}</span></Link>}
                  {permissions.includes("hindranceRead") && <Link to="/reports/hindrance" className={`nav-link nav-link--compact-icon ${path === "/reports/hindrance" ? "active" : ""}`}><i className="bi bi-cone-striped" aria-hidden="true"></i><span>Hindrance Register</span></Link>}
                </div>
              </div>
            </div>
          </div>}

         

          {(userDetails?.roleId?.permission.includes("inventoryRead") || userDetails?.roleId?.permission.includes("ginRead")) && <div class="accordion accordion-flush" id="accordionFlushExample">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                {langPreference?.inventory_management || "Inventory management"}
                </button>
              </h2>
              <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                <div class="accordion-body">
                  {userDetails?.roleId?.permission.includes("inventoryRead") && <Link to="/inventory" className={`nav-link ${path.includes("inventory") ? "active" : ""}`}><span className='pr-2'><img src='/inventory.png' className='tab-icon' /></span> {langPreference?.inventory_setup || "Inventory Setup"}</Link>}

                  {userDetails?.roleId?.permission.includes("ginRead") && <Link to="/gin" className={`nav-link ${path.includes("gin") && !path.includes("goods-return") ? "active" : ""}`}><span className='pr-2'><img src='/goods.png' className='tab-icon' /></span> {langPreference?.goods_issued_note || "Goods Issued Note"}</Link>}
                  {userDetails?.roleId?.permission.includes("ginRead") && <Link to="/goods-return" className={`nav-link ${path.includes("goods-return") ? "active" : ""}`}><span className='pr-2'><img src='/goods.png' className='tab-icon' /></span> {langPreference?.goods_return_note || "Goods Return Note"}</Link>}
                </div>
              </div> 
            </div>
          </div>}


          {/* {userDetails?.roleId?.permission.includes("inventoryRead") && <Link to="/inventory" className={`nav-link ${path.includes("inventory") ? "active" : ""}`}><span className='pr-2'><img src='/inventory.png' className='tab-icon'/></span> Inventory management</Link>}
          
          {userDetails?.roleId?.permission.includes("ginRead") && <Link to="/gin" className={`nav-link ${path.includes("gin") ? "active" : ""}`}><span className='pr-2'><img src='/goods.png' className='tab-icon'/></span> GIN</Link>} */}
          {!isInspector && (userDetails?.roleId?.permission.includes("dprRead") || userDetails?.roleId?.permission.includes("dlrRead") || permissions.includes("cpcRead") || permissions.includes("hindranceRead")) && <div class="accordion accordion-flush" id="daily_report">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button className={`accordion-button ${isDailyReportPath ? "" : "collapsed"}`} type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne-daily_report" aria-expanded={isDailyReportPath} aria-controls="flush-collapseOne">
                {langPreference?.daily_entries || "Daily Entries"}
                </button>
              </h2>
              <div id="flush-collapseOne-daily_report" className={`accordion-collapse collapse ${isDailyReportPath ? "show" : ""}`} aria-labelledby="flush-headingOne" data-bs-parent="#daily_report">
                <div class="accordion-body">
               {userDetails?.roleId?.permission.includes("dprRead") && <Link to="/dpr" className={`nav-link ${path.includes("dpr") ? "active" : ""}`}><span className='pr-2'><img src='/dpr.png' className='tab-icon'/></span>  {langPreference?.daily_progress || "Daily Progress"}</Link>}
              {userDetails?.roleId?.permission.includes("dlrRead") && <Link to="/dlr" className={`nav-link ${path.startsWith("/dlr") && path !== "/dlr/report" ? "active" : ""}`}><span className='pr-2'><img src='/dpr.png' className='tab-icon'/></span>  {langPreference?.daily_labour || "Daily Labour"}</Link>}
              {permissions.includes("cpcRead") && <Link to="/concrete-pour-cards" className={`nav-link nav-link--compact-icon ${path.startsWith("/concrete-pour-cards") ? "active" : ""}`}><i className="bi bi-clipboard-check" aria-hidden="true"></i><span>{langPreference?.concrete_pour_cards || "Concrete Pour Cards"}</span></Link>}
              {permissions.includes("hindranceRead") && <Link to="/hindrance" className={`nav-link nav-link--compact-icon ${path.startsWith("/hindrance") ? "active" : ""}`}><i className="bi bi-cone-striped" aria-hidden="true"></i><span>Hindrance</span></Link>}
                </div>
              </div> 
            </div>
          </div>}


          {userDetails?.roleId?.permission.includes("boqRead") && <Link to="/boq" className={`nav-link ${path.includes("boq") ? "active" : ""}`}><span className='pr-2'><img src='/dpr.png' className='tab-icon'/></span> {langPreference?.boq || "BOQ"}</Link>}
          {userDetails?.roleId?.permission.includes("billingRead") && <div class="accordion accordion-flush" id="billin">
            <div class="accordion-item">
              <h2 class="accordion-header" id="flush-headingOne">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapse_billing" aria-expanded="false" aria-controls="flush-collapseOne">
                {langPreference?.billing || "Billing"}
                </button>
              </h2>
              <div id="flush-collapse_billing" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#billin">
                <div class="accordion-body">
                {userDetails?.roleId?.permission.includes("billingRead") && <Link to="/billing?tab=client&type=billing" className={`nav-link ${search.includes("?tab=client") ? "active" : ""}`}><span className='pr-2'><img src='/dpr.png' className='tab-icon'/></span> {langPreference?.client || "Client"}</Link>}
                {userDetails?.roleId?.permission.includes("billingRead") && <Link to="/billing?tab=subcontractor&type=billing" className={`nav-link ${search.includes("?tab=subcontractor") ? "active" : ""}`}><span className='pr-2'><img src='/dpr.png' className='tab-icon'/></span> {langPreference?.subContractor || "Sub-contractor"}</Link>}
                </div>
              </div> 
            </div>
          </div>}
          {(canAccessTallySetup || canAccessSiteUsers || canAccessSiteSettings) && <div className="accordion accordion-flush" id="admin_setup">
            <div className="accordion-item">
              <h2 className="accordion-header" id="admin-setup-heading">
                <button
                  className={`accordion-button ${path.includes("/admin/") ? "" : "collapsed"}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#admin-setup-collapse"
                  aria-expanded={path.includes("/admin/")}
                  aria-controls="admin-setup-collapse"
                >
                  {langPreference?.admin || "Admin"}
                </button>
              </h2>
              <div
                id="admin-setup-collapse"
                className={`accordion-collapse collapse ${path.includes("/admin/") ? "show" : ""}`}
                aria-labelledby="admin-setup-heading"
                data-bs-parent="#admin_setup"
              >
                <div className="accordion-body">
                  {canAccessSiteSettings && <Link
                    to="/admin/site-settings"
                    className={`nav-link ${path.includes("/admin/site-settings") ? "active" : ""}`}
                  >
                    <span className="pr-2"><i className="bi bi-building-gear tab-icon"></i></span>
                    {langPreference?.site_settings || "Site Settings"}
                  </Link>}
                  {canAccessSiteUsers && <Link
                    to="/admin/users"
                    className={`nav-link ${path.includes("/admin/users") ? "active" : ""}`}
                  >
                    <span className="pr-2"><i className="bi bi-people tab-icon"></i></span>
                    {langPreference?.users || "Users"}
                  </Link>}
                  {canAccessTallySetup && <Link
                    to="/admin/tally-setup"
                    className={`nav-link ${path.includes("/admin/tally-setup") ? "active" : ""}`}
                  >
                    <span className="pr-2"><i className="bi bi-diagram-3 tab-icon"></i></span>
                    {langPreference?.tally_setup || "Tally Setup"}
                  </Link>}
                  {canAccessSiteUsers && <Link
                    to="/admin/company-settings"
                    className={`nav-link ${path.includes("/admin/company-settings") ? "active" : ""}`}
                  >
                    <span className="pr-2"><i className="bi bi-gear tab-icon"></i></span>
                    {langPreference?.company_settings || "Company Settings"}
                  </Link>}
                </div>
              </div>
            </div>
          </div>}
          {/* <div className="logout">
            <Link to="/" data-bs-toggle="modal"
              data-bs-target="#exampleModalout1" className="nav-link">
              <i className="bi bi-box-arrow-left"></i>
              Log Out
            </Link>
          </div> */}

        </div>
        {/* Log out popup code start here */}

      </div>}
    </>

  )
}
